import { ref } from 'vue'

export const MOVE_THEME_STORAGE_KEY = 'move-home-theme'

export function getInitialMoveTheme () {
  if (typeof window === 'undefined') return 'light'
  const stored = localStorage.getItem(MOVE_THEME_STORAGE_KEY)
  if (stored === 'light' || stored === 'dark') return stored
  return window.matchMedia('(prefers-color-scheme: dark)').matches ? 'dark' : 'light'
}

function syncDocumentTheme (isDark) {
  if (typeof document === 'undefined') return
  document.documentElement.classList.toggle('move-theme-dark', isDark)
  document.documentElement.classList.toggle('move-theme-light', !isDark)
}

const isDark = ref(getInitialMoveTheme() === 'dark')
syncDocumentTheme(isDark.value)

export function useMoveTheme () {
  const toggleTheme = () => {
    isDark.value = !isDark.value
    localStorage.setItem(MOVE_THEME_STORAGE_KEY, isDark.value ? 'dark' : 'light')
    syncDocumentTheme(isDark.value)
  }

  const setTheme = (dark) => {
    isDark.value = dark
    localStorage.setItem(MOVE_THEME_STORAGE_KEY, dark ? 'dark' : 'light')
    syncDocumentTheme(dark)
  }

  return { isDark, toggleTheme, setTheme }
}
